<template>
  <div class="keyboard" aria-label="Keyboard">
    <div v-for="(row, i) in rows" :key="i" class="keyboard__row">
      <button
        v-for="k in row"
        :key="k"
        type="button"
        class="key"
        :class="{ 'key--wide': k === '⌫' || k === '⇄' }"
        :aria-label="label(k)"
        @pointerdown.prevent="press(k)"
      >{{ k }}</button>
    </div>
  </div>
</template>

<script>
// The on-screen keyboard, shown on touch devices. A hidden <input> to
// summon the system keyboard is the obvious alternative and the one every
// crossword app abandoned: iOS scrolls the page to it, autocorrect fights
// single letters, and the predictive bar steals a third of the grid.
import { KEYBOARD_ROWS } from '@/engine/solving';

export default {
  name: 'PuzzleKeyboard',
  emits: ['key'],
  data() { return { rows: KEYBOARD_ROWS }; },
  methods: {
    label(k) {
      if (k === '⌫') return 'Backspace';
      if (k === '⇄') return 'Switch direction';
      return k;
    },
    press(k) { this.$emit('key', k); },
  },
};
</script>

<style lang="scss" scoped>
.keyboard {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 4px calc(6px + var(--safe-bottom));
  background: var(--surface);
  border-top: 1px solid var(--edge);
  user-select: none;
  -webkit-user-select: none;
}

.keyboard__row {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.key {
  flex: 1 1 0;
  max-width: 44px;
  min-height: 42px;
  border-radius: 6px;
  background: var(--surface-raised);
  color: var(--ink);
  font-weight: 700;
  font-size: 1.05rem;
  padding: 0;
  touch-action: manipulation;

  &:active { background: var(--accent); color: #211a05; }
  &.key--wide { max-width: 62px; flex-basis: 62px; font-size: 1.1rem; }
}
</style>
